import { createContext, useEffect, useReducer } from "react";
import Reducer from "./Reducer";
import { customFetch } from "../api/usersApi";

const INITIAL_STATE = {
  user: JSON.parse(sessionStorage.getItem("jplAdminUser")) || null,
  // booking: null,
};

customFetch.interceptors.request.use(
  (config) => {
    if (INITIAL_STATE?.user?.accessToken) {
      config.headers[
        "Authorization"
      ] = `Bearer ${INITIAL_STATE?.user?.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const Context = createContext(INITIAL_STATE);

export const ContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, INITIAL_STATE);

  useEffect(() => {
    sessionStorage.setItem("jplAdminUser", JSON.stringify(state.user));
  }, [state.user, state.user?.accessToken]);

  return (
    <Context.Provider
      value={{
        user: state.user,
        // booking: state.booking,
        dispatch,
      }}
    >
      {children}
    </Context.Provider>
  );
};
